import { render } from "./PopupUserContractList.vue?vue&type=template&id=6a544065&scoped=true"
import script from "./PopupUserContractList.vue?vue&type=script&lang=js"
export * from "./PopupUserContractList.vue?vue&type=script&lang=js"

import "./PopupUserContractList.vue?vue&type=style&index=0&id=6a544065&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a544065"]])

export default __exports__